module.exports = __webpack_public_path__ + "img/wealthtop.f88083cc.png";